import { defineMessages } from 'react-intl';

const messages = defineMessages({
  LeaseSetup: {
    id: 'App.LeaseSetup.LeaseSetup',
    defaultMessage: 'Lease and Property Setup',
  },
  paymentProvider: {
    id: 'App.LeaseSetup.paymentProvider',
    defaultMessage: 'Payment Provider',
  },
  petWeightLimit: {
    id: 'App.LeaseSetup.petWeightLimit',
    defaultMessage: 'Pet Weight Limit',
  },
  shortTermLeaseThreshold: {
    id: 'App.LeaseSetup.shortTermLeaseThreshold',
    defaultMessage: 'Short-Term Lease Threshold',
  },
  shortTermLeaseThresholdTooltip: {
    id: 'App.LeaseSetup.shortTermLeaseThresholdTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Set the maximum lease length to be considered short-term. For example, entering 6 months will classify any lease 6 months or shorter as short-term.',
  },
  shortTermLeaseThresholdPlaceholder: {
    id: 'App.LeaseSetup.shortTermLeaseThresholdPlaceholder',
    defaultMessage: 'Select threshold (months)',
  },
  allowedLeaseTerms: {
    id: 'App.LeaseSetup.allowedLeaseTerms',
    defaultMessage: 'Allowed Lease Terms (Months)',
  },
  noLeaseTermsAvailable: {
    id: 'leaseSetup.noLeaseTermsAvailable',
    defaultMessage: 'No Lease Terms Available',
  },
  noSelection: {
    id: 'leaseSetup.noSelection',
    defaultMessage: 'No Selection',
  },
  choose: {
    id: 'leaseSetup.choose',
    defaultMessage: 'Choose',
  },
  month: {
    id: 'leaseSetup.month',
    defaultMessage: 'Month',
  },
  months: {
    id: 'leaseSetup.months',
    defaultMessage: 'Months',
  },
  noValue: {
    id: 'leaseSetup.noValue',
    defaultMessage: '---',
  },
  leaseVariance: {
    id: 'App.LeaseSetup.leaseVariance',
    defaultMessage: 'Lease Variance',
  },
  lateFeeMethod: {
    id: 'App.LeaseSetup.lateFeeMethod',
    defaultMessage: 'Late Fee Method',
  },
  turnDays: {
    id: 'App.BasicDetails.turnDays',
    defaultMessage: 'Turn Days (Maintenance)',
  },
  valueMustBeGreaterThan1: {
    id: 'App.BasicDetails.valueMustBeGreaterOrEqualTo1',
    defaultMessage: 'Value must be greater or equal to 1.',
  },
  required: {
    id: 'App.LeaseSetup.Required',
    defaultMessage: 'Field value is required.',
  },
  cashPrepaidGLCode: {
    id: 'App.LeaseSetup.cashPrepaidGLCode',
    defaultMessage: 'Cash Prepaid GL Code.',
  },
  applicationIncomeRequirement: {
    id: 'App.LeaseSetup.AplicationIncomeRequirement',
    defaultMessage: 'Application Income Requirement',
  },
  applicationAutoScreening: {
    id: 'App.LeaseSetup.ApplicationAutoScreening',
    defaultMessage: 'Application Auto-Screening',
  },
  applicationAutoScreeningTooltip: {
    id: 'App.LeaseSetup.ApplicationAutoScreeningTooltip',
    defaultMessage:
      'When ON, applicant screening runs automatically after an online applicant pays their fees.\n' +
      'When OFF, screening must be run manually.\n' +
      'Note: Applications with fees posted directly to the ledger will always require manual screening.',
  },
  defaultToNoEndDateMonthlyTransactions: {
    id: 'App.LeaseSetup.defaultToNoEndDateMonthlyTransactions',
    defaultMessage: 'Default to No End Date (Monthly Transactions)',
  },
  isNoEndDateActiveTip: {
    id: 'App.LeaseSetup.isNoEndDateActiveTip',
    defaultMessage:
      'This setting will auto-select the “No End Date” checkbox when ' +
      'creating new reoccurring transactions. You will still be able to' +
      ' manually set an end date if desired.',
  },
  adverseLetterDaysTooltipMessage: {
    id: 'App.LeaseSetup.AdverseLetterDaysTooltipMessage',
    defaultMessage:
      // eslint-disable-next-line max-len
      'This setting will specify how long a conditional application approval will be valid for when generating an Adverse Action Letter for an applicant on the Lease App tab.',
  },
  renewalProrate: {
    id: 'App.LeaseSetup.renewalProrate',
    defaultMessage: 'Renewal Prorate',
  },
  firstOfMonthPostLabel: {
    id: 'App.LeaseSetup.firstOfMonthPostLabel',
    defaultMessage: 'Post Initial 1st of Month Charges',
  },
  confirmFirstOfMonthPostLabel: {
    id: 'App.LeaseSetup.confirmFirstOfMonthPostLabel',
    defaultMessage: 'Are you sure you want to post 1st day of month charges?',
  },
  leaseExpirationLimitsLabel: {
    id: 'App.LeaseSetup.leaseExpirationLimitsLabel',
    defaultMessage: 'Lease Expiration Limits',
  },
  moveOutProrate: {
    id: 'App.LeaseSetup.MoveOutProrate',
    defaultMessage: 'Prorate Rent for Move Outs',
  },
  mtmRentSource: {
    id: 'App.LeaseSetup.mtmRentSource',
    defaultMessage: 'MTM Rent Source',
  },
  mtmRentSourceTooltip: {
    id: 'App.LeaseSetup.mtmRentSourceTooltip',
    defaultMessage:
      'Choose how the Month-to-Month (MTM) rent is determined after a lease expires. ' +
      'Select "Lease Rent" to continue charging the same rent as the expired lease, ' +
      'or "Current Quoting Rent" to update the rent to the current quoted amount at lease expiration.',
  },
  leaseRent: {
    id: 'App.LeaseSetup.leaseRent',
    defaultMessage: 'Lease Rent',
  },
  currentQuotingRent: {
    id: 'App.LeaseSetup.currentQuotingRent',
    defaultMessage: 'Current Quoting Rent',
  },
  moveOutProratePlaceholder: {
    id: 'App.LeaseSetup.MoveOutProratePlaceholder',
    defaultMessage: 'Move Out Rent Pro-rate',
  },
  quoteExpirationDate: {
    id: 'App.LeaseSetup.QuoteExpirationDate',
    defaultMessage: 'Quote Expiration Date',
  },
  adverseActionDeadlineDaysLabel: {
    id: 'App.LeaseSetup.AdverseActionDeadlineDaysLabel',
    defaultMessage: 'Adverse Action Deadline (days)',
  },
  valueGreaterThan0: {
    id: 'App.BasicDetails.valueGreaterThan0',
    defaultMessage: 'Value must be greater than 0.',
  },
  valueLessThan999: {
    id: 'App.BasicDetails.valueLessThan999',
    defaultMessage: 'Value must not exceeed 999.',
  },
  valueMustBeWholeNumber: {
    id: 'App.BasicDetails.valueMustBeWholeNumber',
    defaultMessage: 'Value must be a whole number.',
  },
  autoPostMonthlyCharges: {
    id: 'App.LeaseSetup.AutoPostMonthlyCharges',
    defaultMessage: 'Auto-Post Monthly Charges',
  },
  autoPostMonthlyChargesNote: {
    id: 'App.LeaseSetup.AutoPostMonthlyChargesNote',
    defaultMessage: 'Changes will go into affect the next day.',
  },
  autoChargeMtmFeesLabel: {
    id: 'App.LeaseSetup.AutoChargeMtmFeesLabel',
    defaultMessage: 'Auto-Charge Month-to-Month Fees',
  },
  autoChargeMtmFeesTooltip: {
    id: 'App.LeaseSetup.AutoChargeMtmFeesTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'When this setting is On, a month-to-month fee will automatically post to any ledger once the lease expires without a completed renewal in place. A month-to-month fee will continue to post for any household without an active lease on the 1st of every month. Any recurring month-to-month fees will be automatically ended once this feature is turned On to avoid any duplicate charges moving forward.',
  },
  roundProrateRents: {
    id: 'App.LeaseSetup.RoundProrateRents',
    defaultMessage: 'Round Prorated Rents',
  },
  yesRoundProrateRents: {
    id: 'App.LeaseSetup.YesRoundProrateRents',
    defaultMessage: 'Yes - Always Round',
  },
  noRoundProrateRents: {
    id: 'App.LeaseSetup.NoRoundProrateRents',
    defaultMessage: 'No - Never Round',
  },
  successiveLeaseTerm: {
    id: 'App.LeaseSetup.SuccessiveLeaseTerm',
    defaultMessage: 'Successive Lease Term',
  },
  monthToMonth: {
    id: 'App.LeaseSetup.MonthToMonth',
    defaultMessage: 'Month-to-Month',
  },
  annual: {
    id: 'App.LeaseSetup.annual',
    defaultMessage: 'Annual',
  },
  moveOutProrateDesc: {
    id: 'App.LeaseSetup.moveOutProrateDesc',
    defaultMessage: 'Choose how to handle prorated charges for move-outs:',
  },
  yesFullMonth: {
    id: 'App.LeaseSetup.yesFullMonth',
    defaultMessage: 'Yes - Full Month Charge, Reconcile at Move-Out:',
  },
  yesFullMonthDesc: {
    id: 'App.LeaseSetup.yesFullMonthDesc',
    defaultMessage:
      // eslint-disable-next-line max-len
      "This option charges the full month's recurring charges upfront and adjusts the charges at move-out to reflect the actual occupied period.",
  },
  yesStartOfMonth: {
    id: 'App.LeaseSetup.yesStartOfMonth',
    defaultMessage: 'Yes - Prorate at Start of Month:',
  },
  yesStartOfMonthDesc: {
    id: 'App.LeaseSetup.yesStartOfMonthDesc',
    defaultMessage:
      // eslint-disable-next-line max-len
      "This option charges the month's recurring charges based on the anticipated occupied portion of the month according to the scheduled move-out date, and the ledger will be reconciled at move-out for any changes.",
  },
  noNever: {
    id: 'App.LeaseSetup.noNever',
    defaultMessage: 'No - Never Prorate:',
  },
  noNeverDesc: {
    id: 'App.LeaseSetup.noNeverDesc',
    defaultMessage:
      "This option always charges a full month's recurring charges, regardless of the move-out date.",
  },
  housingAssistanceVouchers: {
    id: 'App.LeaseSetup.housingAssistanceVouchers',
    defaultMessage: 'Housing Assistance',
  },
  housingAssistanceVouchersHudTooltip: {
    id: 'App.LeaseSetup.housingAssistanceVouchersHudTooltip',
    defaultMessage: 'This setting is disabled for HUD Section 8 properties.',
  },
  addUtilityNameToUtilityReimbursementChecks: {
    id: 'App.LeaseSetup.addUtilityNameToUtilityReimbursementChecks',
    defaultMessage: 'Add Utility Name to Utility Reimbursement Checks',
  },
  accountingIntegrationLabel: {
    id: 'App.LeaseSetup.AccountingIntegration.label',
    defaultMessage: 'Accounting System',
  },
  accountingIntegrationNotConfigured: {
    id: 'App.LeaseSetup.AccountingIntegration.notConfigured',
    defaultMessage: 'Not Configured',
  },
  agedUpMinorType: {
    id: 'App.LeaseSetup.agedUpMinorType',
    defaultMessage: 'Aged Up Minor Type',
  },
  masterMeteredUtilities: {
    id: 'App.LeaseSetup.masterMeteredUtilities',
    defaultMessage: 'Master Metered Utilities',
  },
  masterMeteredUtilitiesTooltip: {
    id: 'App.LeaseSetup.masterMeteredUtilitiesTooltip',
    defaultMessage:
      'Residents are not responsible for paying any utilities selected here.',
  },
  masterMeteredUtilitiesOther: {
    id: 'App.LeaseSetup.masterMeteredUtilitiesOther',
    defaultMessage: 'Other Master Metered Utilities',
  },
  securityDepositInterest: {
    id: 'App.LeaseSetup.securityDepositInterest',
    defaultMessage: 'Security Deposit Interest',
  },
  securityDepositInterestTooltip: {
    id: 'App.LeaseSetup.securityDepositInterestTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'The interest rate shown is an annual percentage, not a monthly rate. Interest is calculated at the end of each month based on the Deposit Held at that time and the interest rate effective for that month. Accrued interest is then automatically transferred to the resident ledger according to the property’s selected payout frequency—either Monthly, Quarterly, Annually, or at Move-Out.',
  },
  accrueSecurityDepositInterest: {
    id: 'App.LeaseSetup.accrueSecurityDepositInterest',
    defaultMessage: 'Accrue Security Deposit Interest',
  },
  payoutFrequency: {
    id: 'App.LeaseSetup.payoutFrequency',
    defaultMessage: 'Payout Frequency',
  },
  sdiDisabledTooltip: {
    id: 'App.LeaseSetup.sdiDisabledTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'The required transaction codes for this feature is not set up for your property. Please contact your admin team for assistance.',
  },
  subrentCodesDisabledTooltip: {
    id: 'App.LeaseSetup.subrentCodesDisabledTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'The required transaction code for this feature is not set up for your property (SUBRENT). Please contact your admin team for assistance.',
  },
  housingAssistanceDisabled: {
    id: 'App.LeaseSetup.housingAssistanceDisabled',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Housing Assistance cannot be enabled for this property. Please contact your admin team for assistance.',
  },
  lastSprinklerSystemDateLabel: {
    id: 'App.LeaseSetup.lastSprinklerSystemDate.label',
    defaultMessage: 'Last Sprinkler System Inspection Date',
  },
});

export default messages;
